<template>
  <span>
    <my-icon-card
      :icon="index === null ? '+' : index + 1"
      :data="getAllKeys"
      :displayKeys="getDisplayedKeys"
      :color="'#1FDD00'"
      :rows="1"
      :hideLabels="true"
      :hideActiveState="true"
      :menu="beingEdited ? {} : {
        edit: {
          action: () => updateEditingItem(index, serviceKey, descr, group, id),
          icon: 'pencil-alt',
          color: '#7CFF67',
        },
      }"
    >
      <template v-slot:surviceKeyInput>
        <p class='mb-5 red red-text strong mb-15' v-if="beingEdited && error">
          {{ error }}
        </p>
        <h4 :style="{margin: '9px 0'}">{{ serviceKey }}</h4>
        <input
          type="text"
          :value="editingKey"
          v-if="beingEdited"
          placeholder="Service name"
          @change="(e) => handleFieldChange('editingKey', e)"
        />
      </template>
      <template v-slot:surviceEditInput>
        <textarea
          :value="editingValue"
          v-if="beingEdited"
          placeholder="Service description"
          @change="(e) => handleFieldChange('editingValue', e)"
        />
        <div v-if="beingEdited">
          <p class='mb-5'>Category</p>
          <div
            class='row between option-category'
            :class="{'option-new-category': isNewCategory}"
          >
            <select
              @input="e => handleFieldChange('category', e)"
              class='form-field'
            >
              <option
                v-for="option in showCategoryOptions"
                :key="option"
                :selected="option === category || !category && option === '_noCategory'"
              >
                {{ option === '_noCategory'
                  ? 'No category' : option === '_newCategory'
                    ? 'New category'
                    : option
                }}
              </option>
            </select>
            <div v-if="isNewCategory">
              <input
                type='text'
                @change="(e) => handleFieldChange('newCategoryValue', e)"
                :value="newCategoryValue"
                placeholder="Category name"
              />
            </div>
          </div>
        </div>
        <div class="edit-controls right mt-20" v-if="beingEdited">
          <button
            class="btn red"
            @click="handleDeleteItemClick"
            v-if="index !== null"
          >
            Delete item
          </button>
          <button
            class="btn red"
            @click="() => updateEditingItem(null, null, null)"
          >
            Cancel
          </button>
          <button class="btn green" @click="handleSubmitService">
            Submit edits
          </button>
        </div>
      </template>
    </my-icon-card>
  </span>
</template>

<script>
import MyIconCard from "@/myComponents/MyIconCard.vue";
export default {
  components: { MyIconCard },
  name: "servicelistitem",
  props: [
    "index",
    "beingEdited",
    "serviceKey",
    "descr",
    "updateEditingItem",
    "editingKey",
    "editingValue",
    "category",
    "handleSubmitService",
    "handleFieldChange",
    "id",
    "handleDeleteItemClick",
    "categoryOptions",
    "newCategoryValue",
    "group",
    "error"
  ],
  data: function () {
      return {
      allKeys: {
        surviceKeyInput: "my-card-slot",
        sep: "sep",
        descr: this.descr,
        surviceEditInput: "my-card-slot",
        }
      }
  },
  updated: function () {
    if (this.descr !== this.allKeys.descr) {
      this.allKeys = {
        surviceKeyInput: "my-card-slot",
        sep: "sep",
        descr: this.descr,
        surviceEditInput: "my-card-slot",
      }
    }
  },
  computed: {
    getAllKeys: function () {
        return this.allKeys
    },
    showCategoryOptions: function () {
      return ['_newCategory', ...this.categoryOptions]
    },
    getDisplayedKeys: function () {
      return Object.keys(this.allKeys)
    },
    isNewCategory: function () {
      return ['New category', '_newCategory'].includes(this.category)
    }
  }
};
</script>

<style lang='scss'>
.option-category {
  select { 
    width: 100%;
  }
  &.option-new-category {
    select {
      width: 200px;
    }
    div {
      width: calc(100% - 220px);
      display: block;
      input {
        padding: 15px 10px;
      }
    }
    @media screen and (max-width: 550px) {
      flex-direction: column;
      & > select, & > div {
        width: 100%;
        margin: 0 auto 10px auto;
      }
    }
  }
}
</style>